import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons/faAngleDoubleRight";
import { faAsterisk } from "@fortawesome/free-solid-svg-icons/faAsterisk";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import { faBell } from "@fortawesome/free-solid-svg-icons/faBell";
import { faCaretUp } from "@fortawesome/free-solid-svg-icons/faCaretUp";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons/faCaretDown";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons/faCalendarAlt";
import { faCalendar } from "@fortawesome/free-solid-svg-icons/faCalendar";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import { faCheckSquare } from "@fortawesome/free-solid-svg-icons/faCheckSquare";
import { faCog } from "@fortawesome/free-solid-svg-icons/faCog";
import { faCommentAlt } from "@fortawesome/free-solid-svg-icons/faCommentAlt";
import { faCrosshairs } from "@fortawesome/free-solid-svg-icons/faCrosshairs";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import { faExchangeAlt } from "@fortawesome/free-solid-svg-icons/faExchangeAlt";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import { faHdd } from "@fortawesome/free-solid-svg-icons/faHdd";
import { faHeart } from "@fortawesome/free-solid-svg-icons/faHeart";
import { faHome } from "@fortawesome/free-solid-svg-icons/faHome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import { faListAlt } from "@fortawesome/free-solid-svg-icons/faListAlt";
import { faLock } from "@fortawesome/free-solid-svg-icons/faLock";
import { faMobileAlt } from "@fortawesome/free-solid-svg-icons/faMobileAlt";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons/faPaperclip";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons/faPencilAlt";
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";
import { faPoundSign } from "@fortawesome/free-solid-svg-icons/faPoundSign";
import { faProjectDiagram } from "@fortawesome/free-solid-svg-icons/faProjectDiagram";
import { faPhoneSlash } from "@fortawesome/free-solid-svg-icons/faPhoneSlash";
import { faPhone } from "@fortawesome/free-solid-svg-icons/faPhone";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import { faRetweet } from "@fortawesome/free-solid-svg-icons/faRetweet";
import { faSignInAlt } from "@fortawesome/free-solid-svg-icons/faSignInAlt";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons/faSignOutAlt";
import { faSitemap } from "@fortawesome/free-solid-svg-icons/faSitemap";
import { faSortDown } from "@fortawesome/free-solid-svg-icons/faSortDown";
import { faSortUp } from "@fortawesome/free-solid-svg-icons/faSortUp";
import { faStar } from "@fortawesome/free-solid-svg-icons/faStar";
import { faSync } from "@fortawesome/free-solid-svg-icons/faSync";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faSearchPlus } from "@fortawesome/free-solid-svg-icons/faSearchPlus";
import { faThLarge } from "@fortawesome/free-solid-svg-icons/faThLarge";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { faUsers } from "@fortawesome/free-solid-svg-icons/faUsers";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(
  faAngleDoubleRight,
  faAsterisk,
  faArrowLeft,
  faBell,
  faCalendar,
  faCalendarAlt,
  faCaretDown,
  faCaretUp,
  faCheckCircle,
  faCheckSquare,
  faCog,
  faCommentAlt,
  faCrosshairs,
  faEnvelope,
  faExchangeAlt,
  faExclamationCircle,
  faExclamationTriangle,
  faHdd,
  faHeart,
  faHome,
  faInfoCircle,
  faList,
  faListAlt,
  faLock,
  faMobileAlt,
  faPaperclip,
  faPencilAlt,
  faPlus,
  faPhoneSlash,
  faPhone,
  faPoundSign,
  faProjectDiagram,
  faQuestionCircle,
  faRetweet,
  faSearch,
  faSearchPlus,
  faSignInAlt,
  faSignOutAlt,
  faSitemap,
  faSortDown,
  faSortUp,
  faStar,
  faSync,
  faThLarge,
  faUser,
  faUsers,
);

const Icon = props => <FontAwesomeIcon {...props} />;

export default Icon;
